import React from "react";

function Business({ stateObj, setStateObj, UpdateProfile, setCurrentDiv }) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Business Registration Number:</label>
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setStateObj({ ...stateObj, regno: e.target.value })
            }
            value={stateObj.regno}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Tax ID:</label>
          <input
            onChange={(e) =>
              setStateObj({ ...stateObj, taxid: e.target.value })
            }
            value={stateObj.taxid}
            className="form-control"
            type="text"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">No.of years in the industry:</label>
          <input
            type="number"
            className="form-control"
            onChange={(e) =>{
              if (stateObj.activestatus === "True")
              setStateObj({
                ...stateObj,
                yearsinbusiness: e.target.value,
              })
            }}
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe to Enter"
                : "No. of Years"
            }
            value={stateObj.yearsinbusiness}
            readOnly={stateObj.activestatus !== "True"}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="linkedin">Legal Entity:</label>
          <select
            onChange={(e) =>
              setStateObj({
                ...stateObj,
                legalstructure: e.target.value,
              })
            }
            value={stateObj.legalstructure}
            className="form-control"
            id="legalStructure"
            name="legalStructure"
          >
            <option value="">-- Select Legal Entity --</option>
            <option value="sole-proprietorship">Sole Proprietorship</option>
            <option value="partnership">Partnership</option>
            <option value="corporation">Corporation</option>
            <option value="llc">LLC</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>

      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            UpdateProfile();
            setCurrentDiv("service");
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default Business;
